/* Perfectly Cordial 2026 theme: commerce behaviour for the product, shop and collection
   templates. Loaded by the product-main, shop-box-builder, shop-club-popup and
   collection-main sections (the guard below makes repeat loads harmless).

   1. Product page: variant chips (radiogroup with aria-checked, arrow keys), price and
      availability, quantity stepper. Adding goes through the foundation's
      form[data-pc-add-form] handler in pc-cart.js.
   2. Build Your Own Box: flavors from the rendered cards, Pick 4 or Pick 2, repeats allowed,
      pressed states, live count, remove buttons, the bottle flight, the floating dock, the
      ?add= prefill and the Pick 2 third-bottle offer. Two pricing modes, decided in Liquid:
        mode "product": the Box product's 2/3/4 bottle variants give the prices; ONE line of
                        that variant is added with "Bottle n" line item properties.
        mode "bottles": every chosen bottle is its own line at its real Shopify price; the
                        total shown is the real sum, so nothing differs from the cart.
      Cart errors go through PCCart (drawer alert region) and the note under the button.
   3. Shop-only Cordial Club popup after a delay, waiting for open dialogs, cart or menu.
   4. Collection sort menu (navigates with ?sort_by=). */
(function () {
  "use strict";
  if (window.PCShop) return;
  var PC = window.PC || {};
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches || (PC.settings && PC.settings.motion === false);

  function formatMoney(cents) {
    if (window.PCCart && window.PCCart.formatMoney) return window.PCCart.formatMoney(cents);
    var format = PC.moneyFormat || "${{amount}}";
    var value = (Number(cents) || 0) / 100;
    var out = value.toFixed(2);
    if (/amount_no_decimals/.test(format)) out = Math.round(value).toString();
    if (/amount_with_comma_separator/.test(format)) out = out.replace(".", ",");
    out = out.replace(/\B(?=(\d{3})+(?!\d))/g, /comma_separator/.test(format) ? "." : ",");
    return format.replace(/\{\{\s*[a-z_]+\s*\}\}/, out);
  }
  /* "$16" instead of "$16.00" for whole amounts, as the preview's per-bottle notes and its
     copy read ("Choose four bottles for $64", "add a third bottle for $14"); totals and the
     pack price line keep the full money format ("$64.00 · $16 a bottle"), as the preview did */
  function moneyShort(cents) {
    var m = formatMoney(cents);
    return Number(cents) % 100 === 0 ? m.replace(/([.,]00)(?!\d)/, "") : m;
  }
  function fill(template, values) {
    return String(template || "").replace(/\[(\w+)\]/g, function (m, key) {
      return values[key] !== undefined ? values[key] : m;
    });
  }
  function safeText(value) {
    return String(value).replace(/[&<>"']/g, function (ch) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;" }[ch];
    });
  }
  function motionOK() { return !reduceMotion && document.documentElement.classList.contains("anim"); }
  function openDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.showModal === "function") { if (!dialog.open) dialog.showModal(); }
    else dialog.setAttribute("open", "");
    dialog.setAttribute("tabindex", "-1");
    dialog.focus({ preventScroll: true });
  }
  function closeDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === "function") { if (dialog.open) dialog.close(); }
    else dialog.removeAttribute("open");
  }
  function once(el) {
    if (el.getAttribute("data-pc-init") === "1") return false;
    el.setAttribute("data-pc-init", "1");
    return true;
  }

  /* ---------------- 1. product page ---------------- */
  function initProduct(root) {
    if (!once(root)) return;
    var chips = Array.prototype.slice.call(root.querySelectorAll("[data-variant-chip]"));
    var input = root.querySelector("[data-variant-input]");
    var priceEl = root.querySelector("[data-pdp-price]");
    var compareEl = root.querySelector("[data-pdp-compare]");
    var addBtn = root.querySelector("[data-pdp-add]");
    var qtyIn = root.querySelector("[data-qty-input]");
    var dec = root.querySelector("[data-qty-dec]");
    var inc = root.querySelector("[data-qty-inc]");

    function select(chip, focus) {
      chips.forEach(function (c) {
        var on = c === chip;
        c.classList.toggle("on", on);
        c.setAttribute("aria-checked", on ? "true" : "false");
        c.tabIndex = on ? 0 : -1;
      });
      if (input) input.value = chip.getAttribute("data-variant-id");
      if (priceEl) priceEl.textContent = formatMoney(chip.getAttribute("data-price"));
      if (compareEl) {
        var compare = +chip.getAttribute("data-compare") || 0;
        var price = +chip.getAttribute("data-price") || 0;
        if (compare > price) { compareEl.textContent = formatMoney(compare); compareEl.hidden = false; }
        else { compareEl.textContent = ""; compareEl.hidden = true; }
      }
      if (addBtn) {
        var available = chip.getAttribute("data-available") === "true";
        addBtn.disabled = !available;
        addBtn.textContent = available ? addBtn.getAttribute("data-label-add") : addBtn.getAttribute("data-label-sold-out");
      }
      var url = chip.getAttribute("data-url");
      if (url && window.history && history.replaceState) history.replaceState(null, "", url);
      if (focus) chip.focus();
    }
    chips.forEach(function (chip, i) {
      chip.addEventListener("click", function () { select(chip, false); });
      chip.addEventListener("keydown", function (e) {
        var next = null;
        if (e.key === "ArrowRight" || e.key === "ArrowDown") next = chips[(i + 1) % chips.length];
        else if (e.key === "ArrowLeft" || e.key === "ArrowUp") next = chips[(i - 1 + chips.length) % chips.length];
        else if (e.key === "Home") next = chips[0];
        else if (e.key === "End") next = chips[chips.length - 1];
        else if (e.key === " " || e.key === "Enter") { e.preventDefault(); select(chip, false); return; }
        if (next) { e.preventDefault(); select(next, true); }
      });
    });
    function qty() { var v = parseInt(qtyIn && qtyIn.value, 10); return isNaN(v) || v < 1 ? 1 : Math.min(v, 99); }
    if (dec && qtyIn) dec.addEventListener("click", function () { qtyIn.value = Math.max(1, qty() - 1); });
    if (inc && qtyIn) inc.addEventListener("click", function () { qtyIn.value = Math.min(99, qty() + 1); });
    if (qtyIn) qtyIn.addEventListener("change", function () { qtyIn.value = qty(); });
  }

  /* ---------------- 2. Build Your Own Box ---------------- */
  function initBuilder(builder) {
    if (!once(builder)) return;
    var config = { mode: "bottles", variants: {}, strings: {}, propertyLabel: "Bottle [n]" };
    try {
      var cfgEl = builder.querySelector("[data-box-config]");
      if (cfgEl) config = JSON.parse(cfgEl.textContent);
    } catch (err) { /* keep defaults */ }
    var S = config.strings || {};
    var variants = config.variants || {};
    var mode = config.mode === "product" && variants["2"] && variants["4"] ? "product" : "bottles";

    var bundle = [];
    var bundleMode = 4;
    var bundleTarget = 4;
    var bundleSlots = builder.querySelector("[data-bundle-slots]");
    var bundleBox = builder.querySelector("[data-bundle-box]");
    var boxCount = builder.querySelector("[data-box-count]");
    var trayState = builder.querySelector("[data-tray-state]");
    var bundleAdd = builder.querySelector("[data-bundle-add]");
    var bundleClear = builder.querySelector("[data-bundle-clear]");
    var flavorButtons = Array.prototype.slice.call(builder.querySelectorAll("[data-flavor]"));
    var modeButtons = builder.querySelectorAll("[data-bundle-mode]");
    var builderLabel = builder.querySelector("[data-builder-label]");
    var builderTitle = builder.querySelector("[data-builder-title]");
    var builderDescription = builder.querySelector("[data-builder-description]");
    var bundleSummary = builder.querySelector("[data-bundle-summary]");
    var bundleTotal = builder.querySelector("[data-bundle-total]");
    var flavorPicker = builder.querySelector("[data-flavor-picker]");
    var upgradeDialog = builder.querySelector("[data-upgrade-dialog]");
    var upsellHeading = builder.querySelector("[data-upsell-heading]");
    var packHint = builder.querySelector("[data-pack-hint]");
    var errorEl = builder.querySelector("[data-box-error]");
    var stage = builder.querySelector(".byo-stage");
    var dock = builder.querySelector("[data-bundle-dock]");
    var dockSlots = builder.querySelector("[data-dock-slots]");
    var dockState = builder.querySelector("[data-dock-state]");
    var dockTotal = builder.querySelector("[data-dock-total]");
    var dockBtn = builder.querySelector("[data-dock-btn]");
    var inFlight = {};
    var celebrateTimer, thudTimer;
    if (!bundleSlots || !bundleAdd || !bundleClear) return;

    /* single-bottle prices from the cards (cents) */
    var cardPrices = flavorButtons.map(function (b) { return +b.getAttribute("data-price") || 0; }).filter(function (p) { return p > 0; });
    var minPrice = cardPrices.length ? Math.min.apply(null, cardPrices) : 0;
    var allSame = cardPrices.every(function (p) { return p === minPrice; });

    function variantFor(n) { return variants[String(n)] || null; }
    function hasUpsell() {
      if (mode === "product") return !!variantFor(3);
      return cardPrices.length > 0;
    }
    /* the price a box of n bottles will really be charged */
    function priceFor(n, items) {
      if (mode === "product") {
        var v = variantFor(n);
        return v ? v.price : 0;
      }
      var chosen = (items || bundle).slice(0, n).reduce(function (sum, it) { return sum + (it.price || 0); }, 0);
      var remaining = Math.max(0, n - Math.min(n, (items || bundle).length));
      return chosen + remaining * minPrice;
    }
    function isEstimate(n) { return mode === "bottles" && !allSame && bundle.length < n; }
    function upsellPrice() {
      if (mode === "product") {
        var v2 = variantFor(2), v3 = variantFor(3);
        return v2 && v3 ? Math.max(0, v3.price - v2.price) : 0;
      }
      return minPrice;
    }
    function upsellText() {
      var p = moneyShort(upsellPrice());
      if (mode === "bottles" && !allSame) return "from " + p;
      return p;
    }
    function totalText(n) {
      var price = priceFor(n);
      if (isEstimate(n)) return fill(S.from || "From [price]", { price: formatMoney(price) });
      return formatMoney(price);
    }

    function renderStatic() {
      /* "Best value" only when the 4 bottle variant is really cheaper than four singles */
      var packFlag = builder.querySelector("[data-pack-flag]");
      if (packFlag) {
        var v4 = variantFor(4);
        packFlag.hidden = !(mode === "product" && v4 && minPrice > 0 && v4.price < minPrice * 4);
      }
      [4, 2].forEach(function (n) {
        var meta = builder.querySelector("[data-pack-meta='" + n + "']");
        if (!meta) return;
        var price = priceFor(n, []);
        if (mode === "bottles" && !allSame) meta.textContent = fill(S.packMetaFrom || "From [price]", { price: formatMoney(price) });
        else meta.textContent = fill(S.packMeta || "[price] · [per] a bottle", { price: formatMoney(price), per: moneyShort(Math.round(price / n)) });
      });
      if (packHint) {
        if (hasUpsell() && S.hint) { packHint.textContent = fill(S.hint, { upsell: upsellText() }); packHint.hidden = false; }
        else packHint.hidden = true;
      }
      if (upsellHeading && S.upsellHeading) upsellHeading.textContent = fill(S.upsellHeading, { upsell: upsellText() });
    }

    function renderDock() {
      if (!dock) return;
      if (dockSlots) dockSlots.innerHTML = Array.from({ length: bundleTarget }, function (_, i) {
        var item = bundle[i];
        return item && item.img ? '<img src="' + safeText(item.img) + '" alt="" width="27" height="27">' : "<i></i>";
      }).join("");
      if (dockState) dockState.textContent = bundle.length + " of " + bundleTarget;
      if (dockTotal) dockTotal.textContent = totalText(bundleTarget);
    }
    function updateDock() {
      if (!dock || !stage) return;
      var b = builder.getBoundingClientRect();
      var s = stage.getBoundingClientRect();
      var vh = window.innerHeight;
      var show = b.top < vh * 0.55 && b.bottom > vh * 0.6 && s.top > vh - 90;
      dock.classList.toggle("show", show);
      dock.setAttribute("aria-hidden", show ? "false" : "true");
      if (dockBtn) dockBtn.tabIndex = show ? 0 : -1;
    }

    function renderBundle(justFilled, incoming) {
      var complete = bundle.length === bundleTarget;
      var counts = { count: bundle.length, total: bundleTarget };
      if (trayState) {
        trayState.innerHTML = complete
          ? '<span class="ready">' + safeText(fill(S.ready || "Ready to pour: [total] of [total] packed", counts)) + "</span>"
          : safeText(fill(S.packed || "[count] of [total] packed", counts)).replace(String(bundle.length), "<strong>" + bundle.length + "</strong>");
      }
      if (boxCount) boxCount.textContent = fill(S.packed || "[count] of [total] packed", counts);
      bundleSlots.innerHTML = Array.from({ length: bundleTarget }, function (_, index) {
        var item = bundle[index];
        if (!item) return '<div class="box-slot"><span class="slot-num">' + (index + 1) + "</span></div>";
        var state = "";
        if (inFlight[index] || (incoming && justFilled === index)) state = " incoming";
        else if (justFilled === index) state = " landed";
        var label = fill(S.removeFlavor || "Remove [name] from the box", { name: item.name });
        return '<div class="box-slot filled' + state + '"><button class="slot-out" type="button" data-bundle-remove="' + index + '" aria-label="' + safeText(label) + '">' + (item.img ? '<img src="' + safeText(item.img) + '" alt="" width="86" height="192">' : "") + '<span class="slot-x" aria-hidden="true">&times;</span></button></div>';
      }).join("");
      if (bundleBox) bundleBox.classList.toggle("complete", complete);

      bundleAdd.disabled = !complete;
      bundleAdd.textContent = bundleTarget === 2 && hasUpsell() ? (S.review2 || "Review 2 pack") : fill(S.add || "Add [total] pack to cart", counts);
      if (complete && motionOK()) {
        bundleAdd.classList.remove("pulse");
        void bundleAdd.offsetWidth;
        bundleAdd.classList.add("pulse");
      }
      bundleClear.disabled = bundle.length === 0;
      flavorButtons.forEach(function (button) {
        var name = button.getAttribute("data-flavor");
        var soldOut = button.getAttribute("data-available") === "false";
        var selected = bundle.filter(function (item) { return item.name === name; }).length;
        var counter = button.querySelector(".flavor-count");
        button.disabled = soldOut || complete;
        button.classList.toggle("has-selection", selected > 0);
        var aria = fill(S.addFlavor || "Add [name] to the box", { name: name }) + ".";
        if (selected) aria += " " + fill(S.inBox || "[count] in the box.", { count: selected });
        button.setAttribute("aria-label", aria);
        if (counter) counter.textContent = selected ? "× " + selected : "";
      });

      modeButtons.forEach(function (button) {
        var on = +button.getAttribute("data-bundle-mode") === bundleMode;
        button.classList.toggle("on", on);
        button.setAttribute("aria-pressed", on ? "true" : "false");
      });
      var values = { price: moneyShort(priceFor(bundleTarget)), upsell: upsellText() };
      if (builderLabel) builderLabel.textContent = bundleTarget === 3 ? (S.label3 || "") : (S.label || "");
      if (builderTitle) builderTitle.textContent = bundleTarget === 3 ? (S.title3 || "") : bundleMode === 2 ? (S.title2 || "") : (S.title4 || "");
      if (builderDescription) builderDescription.textContent = fill(bundleTarget === 3 ? S.desc3 : bundleMode === 2 ? S.desc2 : S.desc4, values);
      if (bundleSummary) bundleSummary.textContent = bundleTarget === 2 ? (S.summary2 || "") : bundleTarget === 3 ? (S.summary3 || "") : (S.summary4 || "");
      if (bundleTotal) {
        var price = priceFor(bundleTarget);
        var per = fill(S.perBottle || "([per] a bottle)", { per: moneyShort(Math.round(price / bundleTarget)) });
        bundleTotal.innerHTML = safeText(totalText(bundleTarget)) + (isEstimate(bundleTarget) ? "" : ' <span class="per">' + safeText(per) + "</span>");
      }
      if (flavorPicker) flavorPicker.setAttribute("aria-label", fill(S.pickerLabel || "Choose [total] cordial flavors", counts));
      renderDock();
      updateDock();
    }

    function boxThud() {
      if (!bundleBox || !motionOK()) return;
      bundleBox.classList.remove("thud");
      void bundleBox.offsetWidth;
      bundleBox.classList.add("thud");
      clearTimeout(thudTimer);
      thudTimer = setTimeout(function () { bundleBox.classList.remove("thud"); }, 520);
    }
    function celebrate() {
      if (!bundleBox || !motionOK()) return;
      bundleBox.classList.remove("celebrate");
      void bundleBox.offsetWidth;
      bundleBox.classList.add("celebrate");
      clearTimeout(celebrateTimer);
      celebrateTimer = setTimeout(function () { bundleBox.classList.remove("celebrate"); }, 1150);
    }

    /* the bottle you tap lifts off its card, arcs across the page and drops into the box
       (or the floating dock). Skipped under reduced motion. */
    function prepFlight(index, sourceImg) {
      if (!motionOK() || !sourceImg || !bundleSlots) return null;
      var slotEl = bundleSlots.children[index];
      if (!slotEl) return null;
      var dockShown = dock && dock.classList.contains("show");
      var destRect = dockShown && dockSlots ? dockSlots.getBoundingClientRect() : slotEl.getBoundingClientRect();
      if (!destRect || !destRect.width) return null;
      var s = sourceImg.getBoundingClientRect();
      if (!s.width || typeof sourceImg.animate !== "function") return null;
      return function () {
        var targetH = dockShown ? 30 : destRect.height * 0.94;
        var scale = targetH / s.height;
        var clone = sourceImg.cloneNode(false);
        clone.className = "fly-bottle";
        clone.removeAttribute("loading");
        clone.style.left = s.left + "px";
        clone.style.top = s.top + "px";
        clone.style.width = s.width + "px";
        clone.style.height = s.height + "px";
        document.body.appendChild(clone);
        var dx = destRect.left + destRect.width / 2 - (s.left + s.width / 2);
        var dy = destRect.bottom - targetH / 2 - (s.top + s.height / 2);
        inFlight[index] = true;
        var settled = false;
        function settle() {
          if (settled) return;
          settled = true;
          delete inFlight[index];
          if (clone.isConnected) clone.remove();
          var el = bundleSlots.children[index];
          if (el && el.classList.contains("incoming")) {
            el.classList.remove("incoming");
            el.classList.add("landed");
          }
          if (!dockShown) boxThud();
        }
        var flight = clone.animate([
          { transform: "translate(0,0) scale(1) rotate(0deg)" },
          { transform: "translate(" + dx * 0.5 + "px," + (dy * 0.5 - 70) + "px) scale(" + (1 + scale) / 2 + ") rotate(-10deg)", offset: 0.55 },
          { transform: "translate(" + dx + "px," + dy + "px) scale(" + scale + ") rotate(3deg)" }
        ], { duration: 620, easing: "cubic-bezier(.3,.72,.3,1)" });
        flight.onfinish = settle;
        setTimeout(settle, 900);
      };
    }

    function addFlavorFromButton(button, withFlight) {
      if (bundle.length >= bundleTarget) return;
      if (button.getAttribute("data-available") === "false") return;
      var index = bundle.length;
      var sourceImg = button.querySelector(".fcard-art img:not(.fcard-illustration)");
      var flight = withFlight ? prepFlight(index, sourceImg) : null;
      bundle.push({
        name: button.getAttribute("data-flavor"),
        short: button.getAttribute("data-short") || button.getAttribute("data-flavor"),
        img: button.getAttribute("data-img") || "",
        variant: button.getAttribute("data-variant") || "",
        price: +button.getAttribute("data-price") || 0
      });
      if (errorEl) errorEl.textContent = "";
      renderBundle(index, !!flight);
      if (flight) flight();
      if (bundle.length === bundleTarget) celebrate();
    }

    flavorButtons.forEach(function (button) {
      button.addEventListener("click", function () { addFlavorFromButton(button, true); });
    });
    bundleSlots.addEventListener("click", function (event) {
      var removeButton = event.target.closest("[data-bundle-remove]");
      if (!removeButton) return;
      bundle.splice(+removeButton.getAttribute("data-bundle-remove"), 1);
      inFlight = {};
      renderBundle();
      var next = bundleSlots.querySelector("[data-bundle-remove]") || bundleClear;
      if (next && !next.disabled) next.focus({ preventScroll: true });
    });
    bundleClear.addEventListener("click", function () {
      bundle = [];
      inFlight = {};
      if (errorEl) errorEl.textContent = "";
      renderBundle();
    });
    modeButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        bundleMode = +button.getAttribute("data-bundle-mode");
        bundleTarget = bundleMode;
        bundle = bundle.slice(0, bundleTarget);
        inFlight = {};
        renderBundle();
      });
    });

    function addBuiltPack() {
      if (bundle.length !== bundleTarget) return;
      var items;
      if (mode === "product") {
        var v = variantFor(bundleTarget);
        if (!v) { if (errorEl) errorEl.textContent = (PC.strings && PC.strings.cartError) || "Sorry, that did not go through. Please try again."; return; }
        var props = {};
        bundle.forEach(function (item, i) { props[fill(config.propertyLabel || "Bottle [n]", { n: i + 1 })] = item.name; });
        items = [{ id: v.id, quantity: 1, properties: props }];
      } else {
        var byVariant = {};
        var order = [];
        bundle.forEach(function (item) {
          if (!byVariant[item.variant]) { byVariant[item.variant] = 0; order.push(item.variant); }
          byVariant[item.variant] += 1;
        });
        items = order.map(function (id) { return { id: id, quantity: byVariant[id] }; });
      }
      if (!window.PCCart) { if (errorEl) errorEl.textContent = (PC.strings && PC.strings.cartError) || "Sorry, that did not go through. Please try again."; return; }
      if (errorEl) errorEl.textContent = "";
      bundleAdd.disabled = true;
      bundleAdd.setAttribute("aria-busy", "true");
      window.PCCart.add(items, { message: S.added || undefined }).then(function () {
        bundleAdd.removeAttribute("aria-busy");
        bundle = [];
        inFlight = {};
        bundleTarget = bundleMode;
        renderBundle();
      }).catch(function (err) {
        bundleAdd.removeAttribute("aria-busy");
        if (errorEl) errorEl.textContent = (err && (err.description || err.message)) || (PC.strings && PC.strings.cartError) || "Sorry, that did not go through. Please try again.";
        renderBundle();
      });
    }

    bundleAdd.addEventListener("click", function () {
      if (bundle.length !== bundleTarget) return;
      if (bundleMode === 2 && bundleTarget === 2 && hasUpsell() && upgradeDialog) openDialog(upgradeDialog);
      else addBuiltPack();
    });
    if (upgradeDialog) {
      var accept = upgradeDialog.querySelector("[data-upgrade-accept]");
      var decline = upgradeDialog.querySelector("[data-upgrade-decline]");
      var closeBtn = upgradeDialog.querySelector("[data-upgrade-close]");
      if (accept) accept.addEventListener("click", function () {
        closeDialog(upgradeDialog);
        bundleTarget = 3;
        renderBundle();
        var firstAvailable = flavorButtons.filter(function (button) { return !button.disabled; })[0];
        if (firstAvailable) firstAvailable.focus();
      });
      if (decline) decline.addEventListener("click", function () {
        closeDialog(upgradeDialog);
        addBuiltPack();
      });
      if (closeBtn) closeBtn.addEventListener("click", function () { closeDialog(upgradeDialog); });
    }

    /* flavor rail arrows */
    var rail = builder.querySelector("[data-rail]");
    var railArrows = builder.querySelector("[data-rail-arrows]");
    if (rail && railArrows) {
      var railPrev = railArrows.querySelector("[data-rail-prev]");
      var railNext = railArrows.querySelector("[data-rail-next]");
      var railUpdate = function () {
        var over = rail.scrollWidth > rail.clientWidth + 8;
        railArrows.hidden = !over;
        if (!over) return;
        var max = rail.scrollWidth - rail.clientWidth;
        railPrev.disabled = rail.scrollLeft <= 6;
        railNext.disabled = rail.scrollLeft >= max - 6;
      };
      var railBy = function (dir) {
        var card = rail.querySelector(".fcard");
        var step = card ? (card.offsetWidth + 18) * 2 : rail.clientWidth * 0.7;
        rail.scrollBy({ left: dir * step, behavior: reduceMotion ? "auto" : "smooth" });
      };
      railPrev.addEventListener("click", function () { railBy(-1); });
      railNext.addEventListener("click", function () { railBy(1); });
      rail.addEventListener("scroll", railUpdate, { passive: true });
      window.addEventListener("resize", railUpdate, { passive: true });
      railUpdate();
    }

    /* floating dock, re-parented to <body> so the page-enter transform on <main> cannot
       become its containing block. A dock left behind by a theme editor reload is removed. */
    if (dock) {
      var sectionId = builder.getAttribute("data-section-id") || "";
      document.querySelectorAll("body > [data-bundle-dock][data-dock-for='" + sectionId + "']").forEach(function (old) { old.remove(); });
      dock.setAttribute("data-dock-for", sectionId);
      document.body.appendChild(dock);
      dock.hidden = false;
      dock.setAttribute("aria-hidden", "true");
      if (dockBtn) {
        dockBtn.tabIndex = -1;
        dockBtn.addEventListener("click", function () {
          if (stage) stage.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "center" });
        });
      }
      window.addEventListener("scroll", updateDock, { passive: true });
      window.addEventListener("resize", updateDock, { passive: true });
    }

    /* ?add=<handle or preview slug> lands here with that bottle already in the box */
    var preselect = null;
    try { preselect = new URLSearchParams(location.search).get("add"); } catch (err) { preselect = null; }
    if (preselect) {
      var preButton = flavorButtons.filter(function (button) {
        return button.getAttribute("data-handle") === preselect || button.getAttribute("data-slug") === preselect;
      })[0];
      if (preButton && preButton.getAttribute("data-available") !== "false") {
        addFlavorFromButton(preButton, false);
        if (rail) rail.scrollLeft = Math.max(0, preButton.offsetLeft - rail.clientWidth / 2 + preButton.offsetWidth / 2);
      }
    }

    renderStatic();
    renderBundle();
  }

  /* ---------------- 3. Cordial Club popup ---------------- */
  function initPopup(dialog) {
    if (!once(dialog)) return;
    var closeBtn = dialog.querySelector("[data-cordial-close]");
    if (closeBtn) closeBtn.addEventListener("click", function () { closeDialog(dialog); });
    function busy() {
      return document.querySelector("dialog[open]") ||
        document.querySelector(".chat.open") ||
        document.body.classList.contains("cart-open") ||
        document.body.classList.contains("nav-open") ||
        document.body.classList.contains("lb-open");
    }
    function show() {
      if (busy()) { window.setTimeout(show, 1600); return; }
      openDialog(dialog);
    }
    if (dialog.hasAttribute("data-design-mode")) {
      /* theme editor: open when the merchant selects the section, close when they leave it */
      var section = dialog.closest(".shopify-section");
      document.addEventListener("shopify:section:select", function (e) { if (e.target === section) openDialog(dialog); });
      document.addEventListener("shopify:section:deselect", function (e) { if (e.target === section) closeDialog(dialog); });
      return;
    }
    var delay = parseInt(dialog.getAttribute("data-delay"), 10);
    window.setTimeout(show, isNaN(delay) ? 5000 : delay);
  }

  /* ---------------- 4. collection sort ---------------- */
  function initSort(select) {
    if (!once(select)) return;
    select.addEventListener("change", function () {
      var form = select.closest("form");
      if (form) { if (form.requestSubmit) form.requestSubmit(); else form.submit(); return; }
      var url = new URL(location.href);
      url.searchParams.set("sort_by", select.value);
      url.searchParams.delete("page");
      location.assign(url.toString());
    });
  }

  function initAll(scope) {
    scope = scope || document;
    scope.querySelectorAll("[data-product-main]").forEach(initProduct);
    scope.querySelectorAll("[data-bundle-builder]").forEach(initBuilder);
    scope.querySelectorAll("[data-cordial-dialog]").forEach(initPopup);
    scope.querySelectorAll("[data-collection-sort]").forEach(initSort);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { initAll(); });
  else initAll();
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });

  window.PCShop = { init: initAll, formatMoney: formatMoney };
})();
